import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { MANIFESTO, COMPANY } from "@/lib/data";
import { Reveal, Cascade } from "@/components/Reveal";

export default function About() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="hakkimizda" className="scroll-mt-24" data-testid="about">
      <div className="container-shell">
        <div className="grid grid-cols-1 gap-[64px] lg:grid-cols-2 lg:gap-[80px]">
          {/* Left: image */}
          <Reveal className="relative">
            <div
              ref={ref}
              className="relative h-[440px] overflow-hidden rounded-3xl md:h-[560px]"
            >
              <motion.img
                style={{ y: imgY }}
                src="https://images.unsplash.com/photo-1571624436279-b272aff752b5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBtaW5pbWFsaXN0JTIwb2ZmaWNlJTIwYnVzaW5lc3MlMjBtZWV0aW5nfGVufDB8fHx8MTc4NDM4NDcwOHww&ixlib=rb-4.1.0&q=85"
                alt="TEKNO ŞURA ekibi"
                className="h-[116%] w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/30 to-transparent" />
            </div>
            {/* floating badge */}
            <div className="absolute -bottom-6 left-6 flex items-center gap-4 rounded-2xl border border-ink/5 bg-white p-5 shadow-[0_20px_50px_rgba(0,0,0,0.10)] md:left-8">
              <img src="/logo.png" alt="Maskot" className="h-14 w-auto" />
              <div>
                <p className="text-2xl font-extrabold text-ink">30+</p>
                <p className="text-xs text-ink/55">Yıllık Sektör Tecrübesi</p>
              </div>
            </div>
          </Reveal>

          {/* Right: manifesto */}
          <div className="flex flex-col justify-center">
            <Reveal>
              <p className="overline">Hakkımızda</p>
              <h2 className="heading-lg mt-4">
                <Cascade text="Şanlıurfa'nın {güvenilir} teknoloji ortağı." />
              </h2>
              <p className="mt-5 text-lg leading-relaxed text-ink/60">
                {COMPANY.name}, {COMPANY.subtitle.toLowerCase()} olarak işletmelerin dijital
                dönüşüm yolculuğunu baştan sona yönetir.
              </p>
            </Reveal>

            <div className="mt-10 space-y-8">
              {MANIFESTO.map((m, i) => (
                <Reveal key={m.no} delay={i * 0.1}>
                  <div className="flex gap-6 border-t border-ink/10 pt-6">
                    <span className="font-mono text-sm font-bold text-orange">{m.no}</span>
                    <div>
                      <h3 className="text-lg font-bold text-ink">{m.title}</h3>
                      <p className="mt-1.5 text-sm leading-relaxed text-ink/60">{m.body}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
